// klm-client-frontend/src/store/api/base.js
import axios from 'axios';
import { setupCSRF, fetchCSRFToken } from '../../utils/csrfManager';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1';

// ✅ Set REACT_APP_ENV in Vercel dashboard per deployment:
//    klmkart.com          → REACT_APP_ENV=production
//    staging.klmkart.com  → REACT_APP_ENV=staging
//    localhost            → REACT_APP_ENV=local  (in .env.local)
const clientEnv = process.env.REACT_APP_ENV || 'local';

const api = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // ✅ Tell backend which environment this request comes from
    // Backend reads this in maintenanceController & maintenance middleware
    'X-Client-Env': clientEnv,
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

setupCSRF(api);

export const getCSRFToken = async () => {
  try {
    return await fetchCSRFToken();
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
    return null;
  }
};

export default api;